import React from "react";
import dootedLineBottom from "../../assets/images/webp/other/dooted-line-bottom.webp";
import dootedLineTop from "../../assets/images/webp/other/dooted-line-top.webp";
import { BUILDING_LIST } from "../../utils/other-component";
import Icons from "../common/components/Icons";
import BlueTag from "../common/ui/BlueTag";
import Heading from "../common/ui/Heading";

const BuildingPurpose = () => {
  return (
    <>
      <div className="flex items-center justify-center flex-col">
        <BlueTag className="mt-1" center>
          Sustainable. Profitable. Soulful.
        </BlueTag>

        <Heading className="max-w-[864px] mx-auto text-center mt-1">
          Makeway India Group – Building with Purpose
        </Heading>
      </div>
      <div className="flex items-center gap-6 container relative pt-[134px] max-lg:pt-28 max-md:pt-16 max-sm:pt-10 lg:pb-[86px] max-lg:flex-wrap max-lg:justify-center">
        <img
          src={dootedLineTop}
          alt="dooted-line"
          width={300}
          height={90}
          className="w-full max-w-[300px] absolute top-[40px] left-[125px] pointer-events-none max-sm:hidden"
        />
        <img
          src={dootedLineTop}
          alt="dooted-line"
          width={300}
          height={90}
          className="w-full max-w-[300px] absolute top-[40px] right-[125px] pointer-events-none max-md:hidden"
        />
        <img
          src={dootedLineBottom}
          alt="dooted-line"
          width={300}
          height={90}
          className="w-full max-w-[300px] absolute bottom-0 left-[35%] pointer-events-none max-lg:hidden"
        />

        {BUILDING_LIST.map((obj, i) => (
          <div
            key={i}
            className="border border-solid border-[#128D484D] bg-[#EAF3EE] flex items-center flex-col justify-center w-full max-w-[267px] h-[174px] rounded-2xl transition-all ease-linear duration-300 hover:scale-95"
          >
            <Icons icon={obj.icon} />
            <h4 className="text-[#001A3D] text-[28px] leading-[130%] ff-jakarta font-bold pt-2">
              {obj.name}
            </h4>
          </div>
        ))}
      </div>
    </>
  );
};

export default BuildingPurpose;
